import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "核心概念",
  "description": "了解 Turborepo 背后的核心概念。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "了解有关 Turborepo 核心概念的更多信息："
  }, {
    "heading": "",
    "content": "¥Learn more about the core concepts of Turborepo:"
  }],
  "headings": []
};
import {Card, Cards} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "了解有关 Turborepo 核心概念的更多信息："
    }), "\n", _jsx(_components.p, {
      children: "¥Learn more about the core concepts of Turborepo:"
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Remote Caching",
        href: "/docs/core-concepts/remote-caching",
        description: "Save time by never doing the same work twice"
      }), _jsx(Card, {
        title: "Package types",
        href: "/docs/core-concepts/package-types",
        description: "Application and Library Packages"
      }), _jsx(Card, {
        title: "Internal Packages",
        href: "/docs/core-concepts/internal-packages",
        description: "Easily share code inside your repository"
      }), _jsx(Card, {
        title: "Package and Task Graphs",
        href: "/docs/core-concepts/package-and-task-graph",
        description: "How Turborepo relates your tasks to each other"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
